import React from 'react';
import { ProfilePage as ProfilePageComponent } from '../components/Profile';

function ProfilePage() {
  return <ProfilePageComponent />;
}

export default ProfilePage; 